import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  useMediaQuery,
  DialogActions,
  CircularProgress,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { connect } from "react-redux";
import { homeActions } from "actions";
import { homeService } from "services";

const ProductInfo = (props) => {
  const theme = useTheme();
  const {
    showProductInfo,
    onCancel,
    productDetailId,
    gtmInfo,
    updateGTMDataLayer,
  } = props;
  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(false);
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const tagManagerArgs = {
    dataLayer: gtmInfo,
    dataLayerName: "PageDataLayer",
  };

  useEffect(() => {
    setLoading(true);
    homeService
      .getProductInfo(productDetailId)
      .then((res) => {
        updateGTMDataLayer({
          event: "VIEW_PRODUCT_INFO",
        });
        setProductData(res);
        setLoading(false);
      })
      .catch((e) => {
        updateGTMDataLayer({
          event: "VIEW_PRODUCT_INFO",
        });
        setProductData(e.data);
        setLoading(false);
      });

    return () => {
      setProductData(null);
      setLoading(false);
    };
  }, []);

  useEffect(() => {
    if (tagManagerArgs.dataLayer === "VIEW_PRODUCT_INFO") {
      window.dataLayer.push({
        ...tagManagerArgs.dataLayer,
      });
    }
  }, [gtmInfo]);

  return (
    <Box>
      <Dialog
        fullWidth={true}
        maxWidth={productData?.data?.pemURL ? "xl" : "sm"}
        open={showProductInfo}
        className="app-dialog"
        onClose={onCancel}
      >
        <DialogTitle>
          {productData && productData?.data && (
            <div style={{ textAlign: "center" }}>
              <Typography
                sx={{
                  fontSize: matchesMinWidth ? "18px" : "26px",
                  fontFamily: "Lato-Regular",
                  color: theme.palette.primary.main,
                  minHeight: matchesMinWidth ? 20 : 30,
                }}
              >
                {productData?.data?.name}
              </Typography>

              {/* <Typography
                sx={{
                  fontSize: matchesMinWidth ? "10px" : "14px",
                  fontFamily: "Lato-Regular",
                  color: theme.palette.primary.main,
                  minHeight: matchesMinWidth ? 20 : 30,
                }}
              >
                {productData?.data?.strength
                  ? `${productData?.data?.strength}, `
                  : ""}
                {productData?.data?.quantity &&
                  `${
                    productData?.data?.quantity +
                    " " +
                    (productData?.data?.form || "")
                  }`}
              </Typography> */}
            </div>
          )}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ textAlign: "center" }}>
            <Box>
              {loading && <CircularProgress color="inherit" />}
              {!loading && productData?.data?.pemURL && (
                <>
                  <Box mb={7}>
                    <iframe
                      src={`${productData?.data?.pemURL}`}
                      frameBorder="0"
                      border="0"
                      cellSpacing="0"
                      style={{
                        height: "800px",
                        borderStyle: "none",
                        width: "100%",
                      }}
                      title="Details"
                      scrolling="yes"
                    ></iframe>
                  </Box>
                </>
              )}
              {!loading && productData && !productData?.success && (
                <>
                  <Box
                    sx={{ color: "#859AA0", fontFamily: "Lato-Regular" }}
                    mb={7}
                  >
                    {productData?.message}
                  </Box>
                </>
              )}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box
            sx={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            {!loading && (
              <Button
                sx={{
                  minWidth: matchesMinWidth ? 100 : 300,
                }}
                variant="large"
                onClick={() => onCancel()}
              >
                DONE
              </Button>
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    gtmInfo: state.gtmInfo.data,
  };
};

const mapDispatchToProps = {
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductInfo);
